import * as Styles from '../core/styles';
import ApplicationCard from "../core/ApplicationCard";
import { Application } from './ApplicationInterface';
import { IUserIPRestrictionEntity } from '../dealer-admin/ip-access/IPRestrictionInterface';
import DriveApplicationCard from '../drive/DriveApplicationCard';
import MobileApplicationCard from '../components/Cards/MobileApplicationCard';
import { detectDevice } from '../../util/mobileAppUtils';
import { DEVICE } from '../../constants';
import moment from 'moment';
import { useTranslation } from "react-i18next";
import { IAdoptEaseCampaign } from '../adopt-ease/AdoptEaseCampaignInterface';

const findIpRestricted = (ipRestriction:IUserIPRestrictionEntity[], appId:string) =>{
  const data = ipRestriction?.some(
    (item:IUserIPRestrictionEntity) => item.entityType === 'application' 
    && item.entityId === appId 
    && item.isRestricted
  );
  return data;
}

const getTooltipMsg = (ipRestriction:IUserIPRestrictionEntity[], appId:string) =>{
  const data = ipRestriction?.find(
    (item:IUserIPRestrictionEntity) => item.entityType === 'application' 
    && item.entityId === appId 
    && item.isRestricted
  );
  return data;
}

export const getNewIndicator = (app: any ) => {
  if(app.newStatusStartDate && app.newStatusEndDate) {
    const sd = moment.utc(app.newStatusStartDate, 'dddd, MMMM DD, YYYY at h:mm:ss A Z');
    const ed = moment.utc(app.newStatusEndDate, 'dddd, MMMM DD, YYYY at h:mm:ss A Z');
    const now = moment.utc();
    if(now > sd && now < ed) {
      return true;
    }
  }
  return false;
}

export function ApplicationList(props: {
    applications: Application[],
    onClick: Function,
    onCdkUniversityClick: Function,
    onOpenInNewTabClick:Function,
    onFavoriteChange: Function,
    restrictions: IUserIPRestrictionEntity[],
    onSetDefaultApp: (appId: string, appName: string, isDefault: boolean) => void,
    showTryNewAdoptEaseButton: Function,
    onTryNewAdoptEaseClick: Function,
    showTryNewAdoptEaseCampaign?: (id: string) => IAdoptEaseCampaign | undefined,
    isAppDefault: (appId: string) => boolean,
}) {
   const { t } = useTranslation();
  const { applications } = props;
  const device = detectDevice();
  const filteredApps = applications?.filter((app:any) => (app.id !=='CDKU') && (app.id !=='CCPQA') && (app.id !=='CCP') && (app.id !=='DRC')
  && (app.name !== 'Document Management Platform'));

  return (
      <>

          <Styles.CardList>
        {
          filteredApps.map((app:any,index:number) => {
          return app.id === "DMSDRIVE" ? (<DriveApplicationCard
                    key={index}
                    name={app.name}
                    description={app.description}
                    url={app.url}
                    isEnabled={app.isEnabled}
                    isFavorite={app.isFavorite}
                    iconColor={app.icon}
                    iconText={app.iconText}
                    id={app.id}
                    onClick={props.onClick}
                    cdkuUrl={app.cdkuUrl}
                    onFavoriteChange={props.onFavoriteChange}
                    onCdkUniversityClick={props.onCdkUniversityClick}
                    isRestricted={findIpRestricted(props.restrictions,app.id)}
                    restrictedTooltipMsg={getTooltipMsg(props.restrictions,app.id)?.message}
                    isDefault={props.isAppDefault(app.id)}
                    onSetDefaultApp={props.onSetDefaultApp}
                  />
        ) :
          (((device === DEVICE.ANDROID || device === DEVICE.IOS) && app.mobileAppUrl) ? (
            <MobileApplicationCard
              key={index}
              id={app.id}
              name={app.name}
              description={app.description}
              url={app.mobileAppUrl}
              isFavorite={app.isFavorite}
              isEnabled={false}
              iconColor={app.icon}
              iconText={app.iconText}
              cdkuUrl={app.cdkuUrl}
              onCdkUniversityClick={props.onCdkUniversityClick}
              onFavoriteChange={props.onFavoriteChange}
              playStoreUrl={app.mobileAppDownloadUrl?.playStoreUrl || ''}
              appStoreUrl={app.mobileAppDownloadUrl?.appStoreUrl || ''}
              isRestricted={findIpRestricted(props.restrictions,app.id)}
              restrictedTooltipMsg={getTooltipMsg(props.restrictions,app.id)?.message}
            />
          ) : ((device === DEVICE.DESKTOP && app.mobileAppUrl && app.mobileAppUrl !== "" && (!app.url || app.url === "")) ? (
            <MobileApplicationCard
              key={index}
              id={app.id}
              name={app.name}
              description={app.description}
              url={app.mobileAppUrl || ''}
              isFavorite={app.isFavorite}
              isEnabled={true}
              iconColor={app.icon}
              iconText={app.iconText}
              cdkuUrl={app.cdkuUrl}
              onCdkUniversityClick={props.onCdkUniversityClick}
              onFavoriteChange={props.onFavoriteChange}
              playStoreUrl={app.mobileAppDownloadUrl?.playStoreUrl || ''}
              appStoreUrl={app.mobileAppDownloadUrl?.appStoreUrl || ''}
              isRestricted={findIpRestricted(props.restrictions,app.id)}
              restrictedTooltipMsg={getTooltipMsg(props.restrictions,app.id)?.message}
            />
          ) : (
            <ApplicationCard
              key={index}
              name={app.name}
              description={app.description}
              url={app.url}
              isEnabled={app.isEnabled}
              isFavorite={app.isFavorite}
              iconColor={app.icon}
              iconText={app.iconText}
              id={app.id}
              onClick={props.onClick}
              cdkuUrl={app.cdkuUrl}
              onFavoriteChange={props.onFavoriteChange}
              onCdkUniversityClick={props.onCdkUniversityClick}
              onOpenInNewTabClick={props.onOpenInNewTabClick}
              isRestricted={findIpRestricted(props.restrictions,app.id)}
              restrictedTooltipMsg={getTooltipMsg(props.restrictions,app.id)?.message}
              openInNewTab={app.openInNewTab}
              showTryNewAdoptEaseButton={props.showTryNewAdoptEaseButton}
              onTryNewAdoptEaseClick={props.onTryNewAdoptEaseClick}
              showTryNewAdoptEaseCampaign={props.showTryNewAdoptEaseCampaign}
              showNewIndicator={getNewIndicator(app)}
              isDefault={props.isAppDefault(app.id)}
              onSetDefaultApp={props.onSetDefaultApp}
              warningMessage={app.warningMessage}
              requiredOS={app.requiredOS}
            />
          )));
      })
    } 
    </Styles.CardList>
      {filteredApps?.length === 0 && (
            <Styles.UserMessageContainer>
            <Styles.UserMessageHeader>
              {t('appTabs.noAppAssigned')}
            </Styles.UserMessageHeader>
            <Styles.UserMessageDescription>
              {t('appTabs.noAppAssignedDesc')}
            </Styles.UserMessageDescription>
          </Styles.UserMessageContainer>
          )
          }
        </>
  );
}

export default ApplicationList;